import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { WsConst } from '../../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

declare let google: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './key-user-metrics.component.html',
  styleUrls: ['./key-user-metrics.component.css'],
})
export class DashboardComponent extends SuperClass {
  dashboardData: any;

  trafficDownload;
  trafficUpload;
  trafficUploadExistingUser;
  trafficUploadNewUser;
  trafficDownloadExistingUser;
  trafficDownloadNewUser;
  percentile10: string;
  percentile25: string;
  percentile50: string;
  percentile75: string;
  percentile90;
  tcLoginPercent;
  smsLoginPercent;
  loyaltyCardLoginPercent;
  emailLoginPercent;
  emailNoPassLoginPercent;
  googleLoginPercent;
  facebookLoginPercent;
  twitterLoginPercent;
  voucherLoginPercent;
  paidAccessLoginPercent;
  macLoginPercent;
  locations = [];
  sessionsData;
  sparkTrafficDownload;
  sparkTrafficUploadExistingUser;
  sparkTrafficUploadNewUser;
  sparkTrafficDownloadExistingUser;
  sparkTrafficDownloadNewUser;
  sparkTrafficUpload;
  chartOptions;
  lat;
  lng;
  zoom = 4;

  map;
  searchBox;

  constructor(
    private sanitizer: DomSanitizer,
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      {
        label: 'Key User Metrics',
        routerLink: [{ outlets: { sub: [RouterConst.DASHBOARD] } }],
      },
    ]);
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  reloadData() {
    console.log('ses', this.sessionsData);
    this.dashboardDataService.getDD('DashboardComponent');
  }

  setData(data) {
    this.dashboardData = data;

    this.emailLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginEmailPercent}%`,
    );
    this.emailNoPassLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginEmailNoPassPercent}%`,
    );
    this.loyaltyCardLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginLoyaltyCardPercent}%`,
    );
    this.macLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginMACPercent}%`,
    );
    this.smsLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginSMSPercent}%`,
    );
    this.tcLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginTCPercent}%`,
    );
    this.googleLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginGooglePercent}%`,
    );
    this.facebookLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginFacebookPercent}%`,
    );
    this.twitterLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginTwitterPercent}%`,
    );
    this.voucherLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginVoucherPercent}%`,
    );
    this.paidAccessLoginPercent = this.sanitizer.bypassSecurityTrustStyle(
      `width:${this.dashboardData.loginPaidAccessPercent}%`,
    );
    this.percentile90 = this.secondsToHms(
      this.dashboardData.percentile_90_session_time,
    );
    this.percentile75 = this.secondsToHms(
      this.dashboardData.percentile_75_session_time,
    );
    this.percentile50 = this.secondsToHms(
      this.dashboardData.percentile_50_session_time,
    );
    this.percentile25 = this.secondsToHms(
      this.dashboardData.percentile_25_session_time,
    );
    this.percentile10 = this.secondsToHms(
      this.dashboardData.percentile_10_session_time,
    );
    this.trafficUpload = this.formatBytes(this.dashboardData.traffic_upload);
    this.trafficDownload = this.formatBytes(
      this.dashboardData.traffic_download,
    );
    this.trafficUploadExistingUser = this.formatBytes(
      this.dashboardData.traffic_upload_existing_user,
    );
    this.trafficUploadNewUser = this.formatBytes(
      this.dashboardData.traffic_upload_new_user,
    );
    this.trafficDownloadExistingUser = this.formatBytes(
      this.dashboardData.traffic_download_existing_user,
    );
    this.trafficDownloadNewUser = this.formatBytes(
      this.dashboardData.traffic_download_new_user,
    );

    this.chartsInit();
    this.mapInit();
  }

  mapInit() {
    if(!this.dashboardData.venueArray)
      return;

    this.locations = this.dashboardData.venueArray
      .filter(filteredVenue => filteredVenue);
    console.log('loc', this.locations);
  }

  secondsToHms(d) {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);

    const hDisplay = h < 10 ? '0' + h : h;
    const mDisplay = m < 10 ? '0' + m : m;
    const sDisplay = s < 10 ? '0' + s : s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  formatBytes(bytes) {
    if (bytes < 1024) {
      return bytes + ' Bytes';
    } else if (bytes < 1048576) {
      return (bytes / 1024).toFixed(3) + ' KB';
    } else if (bytes < 1073741824) {
      return (bytes / 1048576).toFixed(3) + ' MB';
    } else {
      return (bytes / 1073741824).toFixed(3) + ' GB';
    }
  }

  chartsInit() {
    this.chartOptions = {
      scaleFontColor: 'gray',

      legend: {
        labels: {
          fontColor: 'gray',
        },
      },

      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'gray',
              display: false,
            },
            stacked: true,
          },
        ],

        yAxes: [
          {
            scaleLabel: {
              display: true,
              // labelString: 'Load in %',
              fontColor: 'gray',
            },
            gridLines: {
              color: 'gray',
              display: true,
            },
            stacked: true,
          },
        ],
      },
    };
    this.sessionsData = {
      labels: [
        '0-5m',
        '5-15m',
        '15-30m',
        '30m-1h',
        '1-2h',
        '2-4h',
        '4-8h',
        'Over-8h',
      ],
      datasets: [
        {
          label: this.dashboardData.charts.sessionDuration.label1,
          order: 1,
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.dashboardData.charts.sessionDuration.data1,
        },
        {
          label: this.dashboardData.charts.sessionDuration.label2,
          order: 2,
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          data: this.dashboardData.charts.sessionDuration.data2,
        },
      ],
    };
    this.sparkTrafficDownload = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Download',
          backgroundColor: '#63C7B2',
          hoverBackgroundColor: '#9BDBCE',
          data: this.dashboardData.charts.sparkTrafficDownload.data,
        },
      ],
    };
    this.sparkTrafficDownloadExistingUser = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Download Existing Users',
          backgroundColor: '#63C7B2',
          hoverBackgroundColor: '#9BDBCE',
          data: this.dashboardData.charts.sparkTrafficDownloadRetUsers.data,
        },
      ],
    };
    this.sparkTrafficDownloadNewUser = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Download New User',
          backgroundColor: '#63C7B2',
          hoverBackgroundColor: '#9BDBCE',
          data: this.dashboardData.charts.sparkTrafficDownloadNewUsers.data,
        },
      ],
    };
    this.sparkTrafficUpload = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Upload',
          backgroundColor: '#75BCC4',
          hoverBackgroundColor: '#B3DADE',
          data: this.dashboardData.charts.sparkTrafficUpload.data,
        },
      ],
    };
    this.sparkTrafficUploadExistingUser = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Upload Existing User',
          backgroundColor: '#75BCC4',
          hoverBackgroundColor: '#B3DADE',
          data: this.dashboardData.charts.sparkTrafficUploadRetUsers.data,
        },
      ],
    };
    this.sparkTrafficUploadNewUser = {
      labels: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      datasets: [
        {
          label: 'Traffic Upload New User',
          backgroundColor: '#75BCC4',
          hoverBackgroundColor: '#B3DADE',
          data: this.dashboardData.charts.sparkTrafficUploadNewUsers.data,
        },
      ],
    };
    // this.allTypesLogin = {
    //   labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    //   datasets: [
    //     {
    //       label: this.dashboardData.charts.loginTypes.email,
    //       order: 1,
    //       backgroundColor: '#F6BD60',
    //       hoverBackgroundColor: '#FFE082',
    //       data: this.dashboardData.charts.allLoginType.data1
    //     }
    //     ]
    // };
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/key-user-metrics/key-user-metrics.component.ts